import React from 'react';

import Browser from '@wetransfer/transfer/modules/concorde-browser';

import { SellerNameProps } from './types';

const BY_LABEL = 'by';

export const SellerName: React.FC<SellerNameProps> = React.memo(
  function SellerName({ name }) {
    const body = `${BY_LABEL} ${name}`;

    if (Browser.isMobile) {
      return <>{body}</>;
    }

    return <p>{body}</p>;
  }
);
